import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setDetail(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired","failed"].includes(data.payment_status)) { setStatus("error"); return; }
        attempts++;
        if (attempts > 20) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      {status === "polling" && (
        <>
          <Loader2 className="w-14 h-14 text-[#2C5530] animate-spin mx-auto"/>
          <h1 className="mt-6 text-3xl tracking-tighter font-light">Confirming your purchase…</h1>
          <p className="text-stone-600 mt-2">This usually takes a few seconds.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 text-[#2C5530] mx-auto"/>
          <h1 className="mt-6 text-4xl tracking-tighter font-light" data-testid="success-title">You just made a difference</h1>
          {detail && (
            <p className="text-stone-600 mt-3">
              <span className="font-medium">{detail.tons} tons</span> of CO₂ offset via <span className="font-medium">{detail.project_name}</span>. Certificate ready in your dashboard.
            </p>
          )}
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/dashboard"><Button data-testid="go-dashboard" className="bg-[#2C5530] hover:bg-[#1F3D22] text-white rounded-full h-11 px-6">View certificate</Button></Link>
            <Link to="/marketplace"><Button variant="outline" className="rounded-full h-11 px-6">Buy more</Button></Link>
          </div>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <XCircle className="w-16 h-16 text-red-500 mx-auto"/>
          <h1 className="mt-6 text-3xl tracking-tighter font-light">Something went wrong</h1>
          <p className="text-stone-600 mt-2">We couldn't confirm the payment. Check your dashboard or try again.</p>
          <Link to="/marketplace"><Button className="mt-6 rounded-full">Back to marketplace</Button></Link>
        </>
      )}
    </div>
  );
}
